import { render, staticRenderFns } from "./upload-image.vue?vue&type=template&id=762bf71f"
import script from "./upload-image.vue?vue&type=script&lang=js"
export * from "./upload-image.vue?vue&type=script&lang=js"
import style0 from "./upload-image.vue?vue&type=style&index=0&id=762bf71f&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('762bf71f')) {
      api.createRecord('762bf71f', component.options)
    } else {
      api.reload('762bf71f', component.options)
    }
    module.hot.accept("./upload-image.vue?vue&type=template&id=762bf71f", function () {
      api.rerender('762bf71f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/upload-image.vue"
export default component.exports